import React, { Component } from 'react'
import { connect } from 'react-redux'
import Joyride from 'react-joyride'
import Tour from 'reactour'
import SplashScreen from './SplashScreen'
import SplashScreenPolarView from './SplashScreenPolarView'
import TopNav from './TopNav'
import RightNavigation from './RightNavigation'
import ServiceNavigation from './ServiceNavigation'
import MapboxMap from '../containers/MapboxMap'
import LocationContainer from './LocationContainer'
import LegendContainer from './LegendContainer'
import NotificationsContainer from './NotificationsContainer'
import UploadContainer from './UploadContainer'
import HoverContainer from './HoverContainer'
import ItemSummaryFloatContainer from './ItemSummaryFloatContainer'
import ClockDissolveContainer from './ClockDissolveContainer'
import Authenticate from '../api/Authenticate'
import LoginActions from '../redux/loginRedux'
import MapActions from '../redux/mapRedux'
import { POLAR_VIEW } from '../config/services'
import steps from '../tour/steps'
import { withErrorBoundary } from '../errors/ErrorBoundary'

const authenticate = new Authenticate()

class Root extends Component {
  state = {
    isTourOpen: false,
    isShowingMore: false
  }

  componentWillMount () {
    const { actions } = this.props
    authenticate.handleAuthentication(actions.loginFulfilled)
  }

  componentDidMount () {
    const { actions } = this.props
    // authenticate.handleAuthentication(actions.loginFulfilled)
    actions.authenticate()
  }

  toggleShowMore = () => {
    this.setState(prevState => ({
      isShowingMore: !prevState.isShowingMore,
    }))
  }

  closeTour = () => {
    this.setState({ isTourOpen: false })
  }

  openTour = () => {
    this.setState({ isTourOpen: true })
  }

  render () {
    const { actions, pitch, pitchControlVisible } = this.props
    const { isTourOpen, isShowingMore } = this.state

    return (
      <div style={{ height: '100%' }}>
        <Tour
          steps={steps}
          isOpen={isTourOpen}
          onRequestClose={this.closeTour}
          maskClassName='mask'
          className='helper'
          />
        <UploadContainer />
        { POLAR_VIEW ? <SplashScreenPolarView /> : <SplashScreen /> }
        <MapboxMap />
        <RightNavigation />
        <TopNav />
        <LegendContainer />
        <LocationContainer />
        <ServiceNavigation />
        <NotificationsContainer />
        <HoverContainer />
        <ItemSummaryFloatContainer id='WellsiteRank' />
        <ItemSummaryFloatContainer id='PipelineChangeDetection' />
        <ClockDissolveContainer />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    pitch: state.map.pitch,
    pitchControlVisible: state.map.pitchControlVisible
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      authenticate: () => dispatch(LoginActions.authenticate()),
      loginFulfilled: (accessToken, idToken, expiresAt) =>
        dispatch(LoginActions.loginFulfilled(accessToken, idToken, expiresAt)),
      pitchChanged: pitch => dispatch(MapActions.pitchChanged(pitch))
    }
  }
}

export default withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(Root))



// WEBPACK FOOTER //
// ./src/containers/Root.js